<template>
  <v-autocomplete
    v-model="selected"
    :items="vehicles"
    :filter="filter"
    item-value="vehicleId"
    :search-input.sync="search"
    :error-messages="errorMessages"
    flat
    chips
    multiple
    :rounded="rounded"
    :label="$t('component.vehicles_field.title')"
    clearable
  >
    <template v-slot:selection="item">
      <v-chip
        v-bind="item.attrs"
        :input-value="item.selected"
        close
        small
        @click="item.select"
        @click:close="removeItem(item.item.vehicleId)"
      >
        {{ item.item.numericPlate }}
      </v-chip>
    </template>

    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.numericPlate"></v-list-item-title>
        <v-list-item-subtitle v-text="item.name"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
/*
 * model input value format:
 *   vehicle object
 */
export default {
  name: "VehiclesField",
  props: {
    value: {
      type: Array
    },
    rounded: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selected: null,
      search: null,
      disableEmit: false
    };
  },

  methods: {
    filter(item, queryText) {
      const text = item.numericPlate.toLowerCase() + " " + item.name.toLowerCase();
      return text.indexOf(queryText.toLowerCase()) > -1;
    },

    setValue(value) {
      this.selected = (value !== null) ? value.map(x => x.vehicleId) : null;
    },

    removeItem(item) {
      const index = this.selected.indexOf(item);
      if (index >= 0)
        this.selected.splice(index, 1);
    }
  },

  watch: {
    selected: function() {
      if (!this.disableEmit)
        this.$emit("input", this.vehicles.filter(x => this.selected !== null && this.selected.includes(x.vehicleId)) || null);
      else
        this.disableEmit = false;
    },

    value: function() {
      this.disableEmit = true;
      this.setValue(this.value);
    }
  },

  computed: {
    vehicles: function() {
      return this.$store.state.online.vehicles;
    }
  },

  mounted() {
    this.disableEmit = true;
    this.setValue(this.value);
    this.$nextTick().then(() => {
      this.disableEmit = false;
    });
  }
};
</script>

<style scoped>

</style>